import type {RouteRecordRaw} from 'vue-router';
import {createPropositionGuard} from '@myparcel-frontend/proposition';
import {ecommercePlatformGuard} from '../guards/ecommerce-platform-guard';
import {salesChannelsGuard} from '../guards/sales-channels-guard';

export const shopSettingsSalesChannelsRoutes: RouteRecordRaw[] = [
  {
    path: 'sales-channels',
    beforeEnter: [
      createPropositionGuard((proposition) => proposition.enableSalesChannels, {
        name: 'dashboard',
      }),
      salesChannelsGuard,
    ],
    children: [
      {
        name: 'sales-channels',
        props: true,
        path: '',
        component: () => import('@/views/SalesChannels/SalesChannelsIndex/SalesChannelsIndex.vue'),
        meta: {
          title: (t) => t('integrations.salesChannels.title'),
        },
      },
      {
        name: 'sales-channels-create',
        path: 'create',
        props: true,
        component: () => import('@/views/SalesChannels/SalesChannelsCreate/SalesChannelsCreate.vue'),
        meta: {
          title: (t) => t('integrations.salesChannels.create'),
        },
      },
      {
        name: 'sales-channels-edit',
        path: ':ecommercePlatform/:salesChannelId',
        props: (route) => ({
          shopId: route.params.shopId,
          ecommercePlatform: Array.isArray(route.params.ecommercePlatform)
            ? route.params.ecommercePlatform[0]
            : route.params.ecommercePlatform,
          salesChannelId: route.params.salesChannelId,
        }),
        beforeEnter: ecommercePlatformGuard,
        component: () => import('@/views/SalesChannels/SalesChannelsEdit/SalesChannelsEdit.vue'),
        meta: {
          title: (t) => t('integrations.salesChannels.edit'),
        },
        children: [
          {
            name: 'sales-channels-edit-settings',
            path: '',
            props: true,
            component: () =>
              import('@/views/SalesChannels/SalesChannelsEdit/SalesChannelsEditSettings/SalesChannelsEditSettings.vue'),
            meta: {
              title: (t) => t('integrations.salesChannels.edit'),
            },
          },
        ],
      },
    ],
  },
];
